import React from 'react';
import { Menu, Layout } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const { Header } = Layout;

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleLogout = () => {
    localStorage.setItem('currentUser', null);
    navigate('/');
    window.location.reload(); 
  };

  return (
    <Header style={{ display: 'flex', justifyContent: 'space-between', backgroundColor:'transparent',alignItems: 'center',  boxShadow:'0 4px 6px rgba(255, 255, 255, 0.2)',width:'100vw',margin:0 }}>
      <div className="logo" style={{ color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
        TicTacToe
      </div>
      <Menu
        mode="horizontal"
        style={{ flex: 1, justifyContent: 'flex-end',backgroundColor:'transparent'}}
        selectedKeys={[currentPath]}
      >
        <Menu.Item style={{color:'white'}} key="/game" onClick={() => navigate('/game')}>
          Game
        </Menu.Item>
        <Menu.Item  style={{color:'white'}}key="/profile" onClick={() => navigate('/profile')}>
          Profile
        </Menu.Item>
        <Menu.Item style={{color:'white'}} key="/leaderboard" onClick={() => navigate('/leaderboard')}>
          Leaderboard
        </Menu.Item>
        <Menu.Item style={{color:'white', fontWeight:'bold'}}>
          <span style={{color:'white', fontWeight:'bold', border: '2px solid white', borderRadius: '5px', padding: '8px 12px'}} onClick={() => handleLogout()}>
            Logout
          </span>
        </Menu.Item>
      </Menu>
    </Header>
  );
};

export default Navbar;
